"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.npcDialogueWorldMenu = void 0;
const retrommo_types_1 = require("retrommo-types");
const pixel_pigeon_1 = require("pixel-pigeon");
const NPC_1 = require("../classes/NPC");
const Quest_1 = require("../classes/Quest");
const QuestState_1 = require("../types/QuestState");
const WorldCharacter_1 = require("../classes/WorldCharacter");
const WorldMenu_1 = require("../classes/WorldMenu");
const createIconListItem_1 = require("../functions/ui/components/createIconListItem");
const createImage_1 = require("../functions/ui/components/createImage");
const createPanel_1 = require("../functions/ui/components/createPanel");
const createPressableButton_1 = require("../functions/ui/components/createPressableButton");
const createUnderstrike_1 = require("../functions/ui/components/createUnderstrike");
const definables_1 = require("definables");
const getFormattedInteger_1 = require("../functions/getFormattedInteger");
const getQuestGiverQuests_1 = require("../functions/getQuestGiverQuests");
const getQuestIconImagePath_1 = require("../functions/getQuestIconImagePath");
const getQuestIconRecolors_1 = require("../functions/getQuestIconRecolors");
const getQuestPartyState_1 = require("../functions/getQuestPartyState");
const getWorldState_1 = require("../functions/state/getWorldState");
const isWorldCombatInProgress_1 = require("../functions/isWorldCombatInProgress");
const constants_1 = require("../constants");
exports.npcDialogueWorldMenu = new WorldMenu_1.WorldMenu({
    create: (options) => {
        const labelIDs = [];
        const hudElementReferences = [];
        const npc = (0, definables_1.getDefinable)(NPC_1.NPC, options.npcID);
        const width = (0, pixel_pigeon_1.getGameWidth)();
        const height = 72;
        const x = 0;
        const y = 136;
        const xOffset = 10;
        const worldState = (0, getWorldState_1.getWorldState)();
        const worldCharacter = (0, definables_1.getDefinable)(WorldCharacter_1.WorldCharacter, worldState.values.worldCharacterID);
        const getSelectedQuest = () => {
            if (exports.npcDialogueWorldMenu.state.values.selectedQuestIndex === null) {
                return null;
            }
            const questGiverQuest = npc.questGiver.quests[exports.npcDialogueWorldMenu.state.values.selectedQuestIndex];
            if (typeof questGiverQuest === "undefined") {
                throw new Error("No quest giver quest.");
            }
            return (0, definables_1.getDefinable)(Quest_1.Quest, questGiverQuest.questID);
        };
        // Background panel
        hudElementReferences.push((0, createPanel_1.createPanel)({
            condition: () => (0, isWorldCombatInProgress_1.isWorldCombatInProgress)() === false,
            height,
            imagePath: "panels/basic",
            width,
            x,
            y,
        }));
        // Close button
        hudElementReferences.push((0, createImage_1.createImage)({
            condition: () => (0, isWorldCombatInProgress_1.isWorldCombatInProgress)() === false,
            height: 11,
            imagePath: "x",
            onClick: () => {
                if (worldCharacter.player.character.party.playerIDs[0] ===
                    worldCharacter.playerID) {
                    if (exports.npcDialogueWorldMenu.state.values.selectedQuestIndex !== null) {
                        exports.npcDialogueWorldMenu.state.setValues({
                            selectedQuestIndex: null,
                        });
                    }
                    else if (exports.npcDialogueWorldMenu.state.values.questCompletion !== null) {
                        exports.npcDialogueWorldMenu.state.setValues({
                            questCompletion: null,
                        });
                    }
                    else {
                        exports.npcDialogueWorldMenu.close();
                    }
                }
                else {
                    exports.npcDialogueWorldMenu.close();
                }
            },
            width: 10,
            x: x + width - 17,
            y: y + 7,
        }));
        // Name
        labelIDs.push((0, pixel_pigeon_1.createLabel)({
            color: retrommo_types_1.Color.White,
            coordinates: {
                condition: () => (0, isWorldCombatInProgress_1.isWorldCombatInProgress)() === false,
                x: x + xOffset,
                y: y + 10,
            },
            horizontalAlignment: "left",
            maxLines: 1,
            maxWidth: width - xOffset * 2,
            size: 1,
            text: () => {
                if (exports.npcDialogueWorldMenu.state.values.questCompletion !== null) {
                    const quest = (0, definables_1.getDefinable)(Quest_1.Quest, exports.npcDialogueWorldMenu.state.values.questCompletion.questID);
                    return { value: `Quest Complete: ${quest.name}` };
                }
                const pieces = [npc.name];
                const quest = getSelectedQuest();
                if (quest !== null) {
                    pieces.push(quest.name);
                }
                return {
                    value: pieces.join(" - "),
                };
            },
        }));
        // Dialogue
        labelIDs.push((0, pixel_pigeon_1.createLabel)({
            color: retrommo_types_1.Color.White,
            coordinates: {
                condition: () => npc.hasDialogue() &&
                    exports.npcDialogueWorldMenu.state.values.questCompletion === null &&
                    (0, isWorldCombatInProgress_1.isWorldCombatInProgress)() === false,
                x: x + xOffset,
                y: y + 23,
            },
            horizontalAlignment: "left",
            maxLines: 3,
            maxWidth: width - xOffset * 2,
            size: 1,
            text: () => {
                const quest = getSelectedQuest();
                if (quest !== null) {
                    switch ((0, getQuestPartyState_1.getQuestPartyState)(quest.id)) {
                        case QuestState_1.QuestState.Accept:
                            return {
                                value: quest.availableText,
                            };
                        case QuestState_1.QuestState.Complete:
                        case QuestState_1.QuestState.TurnIn:
                            return {
                                value: quest.completedText,
                            };
                        case QuestState_1.QuestState.InProgress:
                            return {
                                value: quest.inProgressText,
                            };
                    }
                }
                return {
                    value: npc.dialogue,
                };
            },
        }));
        const questsX = 176;
        const questsY = 49;
        const questsWidth = x + width - questsX;
        const questsHeight = y - questsY;
        if (npc.hasQuestGiver()) {
            if (options.isLeader) {
                // Quest panel
                hudElementReferences.push((0, createPanel_1.createPanel)({
                    condition: () => (0, isWorldCombatInProgress_1.isWorldCombatInProgress)() === false,
                    height: questsHeight,
                    imagePath: "panels/basic",
                    width: questsWidth,
                    x: questsX,
                    y: questsY,
                }));
                // Close quests button
                hudElementReferences.push((0, createImage_1.createImage)({
                    condition: () => (0, isWorldCombatInProgress_1.isWorldCombatInProgress)() === false,
                    height: 11,
                    imagePath: "x",
                    onClick: () => {
                        exports.npcDialogueWorldMenu.close();
                    },
                    width: 10,
                    x: questsX + questsWidth - 17,
                    y: questsY + 7,
                }));
                // Quests heading
                labelIDs.push((0, pixel_pigeon_1.createLabel)({
                    color: retrommo_types_1.Color.White,
                    coordinates: {
                        condition: () => (0, isWorldCombatInProgress_1.isWorldCombatInProgress)() === false,
                        x: questsX + Math.round(questsWidth / 2),
                        y: questsY + 9,
                    },
                    horizontalAlignment: "center",
                    maxLines: 1,
                    maxWidth: questsWidth - 16,
                    size: 1,
                    text: {
                        value: "Quests",
                    },
                }));
                // Quests understrike
                hudElementReferences.push((0, createUnderstrike_1.createUnderstrike)({
                    condition: () => (0, isWorldCombatInProgress_1.isWorldCombatInProgress)() === false,
                    width: questsWidth - 16,
                    x: questsX + 8,
                    y: questsY + 20,
                }));
                // Quests list
                for (let i = 0; i < constants_1.npcQuestsPerPage; i++) {
                    const index = i;
                    const getQuest = () => {
                        const questGiverQuest = (0, getQuestGiverQuests_1.getQuestGiverQuests)(npc.id)[i];
                        if (typeof questGiverQuest === "undefined") {
                            throw new Error("No quest giver quest.");
                        }
                        return (0, definables_1.getDefinable)(Quest_1.Quest, questGiverQuest.questID);
                    };
                    hudElementReferences.push((0, createIconListItem_1.createIconListItem)({
                        condition: () => (0, getQuestGiverQuests_1.getQuestGiverQuests)(npc.id).length > i &&
                            (0, isWorldCombatInProgress_1.isWorldCombatInProgress)() === false,
                        icons: [
                            {
                                imagePath: () => (0, getQuestIconImagePath_1.getQuestIconImagePath)(getQuest().id),
                            },
                            {
                                condition: () => {
                                    const questState = (0, getQuestPartyState_1.getQuestPartyState)(getQuest().id);
                                    return ((questState === QuestState_1.QuestState.InProgress ||
                                        questState === QuestState_1.QuestState.TurnIn) &&
                                        (0, isWorldCombatInProgress_1.isWorldCombatInProgress)() === false);
                                },
                                imagePath: "quest-banners/default",
                                recolors: () => (0, getQuestIconRecolors_1.getQuestIconRecolors)(getQuest().id, true),
                            },
                        ],
                        isSelected: () => exports.npcDialogueWorldMenu.state.values.selectedQuestIndex === i,
                        onClick: () => {
                            if (exports.npcDialogueWorldMenu.state.values.selectedQuestIndex === i) {
                                exports.npcDialogueWorldMenu.state.setValues({
                                    selectedQuestIndex: null,
                                });
                                (0, pixel_pigeon_1.emitToSocketioServer)({
                                    data: {},
                                    event: "world/select-quest",
                                });
                            }
                            else {
                                exports.npcDialogueWorldMenu.state.setValues({
                                    questCompletion: null,
                                    selectedQuestIndex: index,
                                });
                                (0, pixel_pigeon_1.emitToSocketioServer)({
                                    data: {
                                        questID: getQuest().id,
                                    },
                                    event: "world/select-quest",
                                });
                            }
                        },
                        slotImagePath: "slots/basic",
                        text: () => ({ value: getQuest().name }),
                        width: 116,
                        x: questsX + 6,
                        y: questsY + 26 + i * 18,
                    }));
                }
                // Quest accept button
                const acceptButtonWidth = 64;
                hudElementReferences.push((0, createPressableButton_1.createPressableButton)({
                    condition: () => {
                        const quest = getSelectedQuest();
                        if (quest !== null) {
                            return ((0, getQuestPartyState_1.getQuestPartyState)(quest.id) === QuestState_1.QuestState.Accept &&
                                (0, isWorldCombatInProgress_1.isWorldCombatInProgress)() === false);
                        }
                        return false;
                    },
                    height: 16,
                    imagePath: "pressable-buttons/gray",
                    onClick: () => {
                        const quest = getSelectedQuest();
                        if (quest === null) {
                            throw new Error("No selected quest.");
                        }
                        (0, pixel_pigeon_1.emitToSocketioServer)({
                            data: {
                                questID: quest.id,
                            },
                            event: "world/accept-quest",
                        });
                    },
                    text: {
                        value: "Accept",
                    },
                    width: acceptButtonWidth,
                    x: x + width - acceptButtonWidth - 7,
                    y: y + height - 23,
                }));
                // Quest turn in button
                const turnInButtonWidth = 64;
                hudElementReferences.push((0, createPressableButton_1.createPressableButton)({
                    condition: () => {
                        const quest = getSelectedQuest();
                        if (quest !== null) {
                            return ((0, getQuestPartyState_1.getQuestPartyState)(quest.id) === QuestState_1.QuestState.TurnIn &&
                                (0, isWorldCombatInProgress_1.isWorldCombatInProgress)() === false);
                        }
                        return false;
                    },
                    height: 16,
                    imagePath: "pressable-buttons/gray",
                    onClick: () => {
                        const quest = getSelectedQuest();
                        if (quest === null) {
                            throw new Error("No selected quest.");
                        }
                        (0, pixel_pigeon_1.emitToSocketioServer)({
                            data: {
                                questID: quest.id,
                            },
                            event: "world/turn-in-quest",
                        });
                    },
                    text: {
                        value: "Complete",
                    },
                    width: turnInButtonWidth,
                    x: x + width - turnInButtonWidth - 7,
                    y: y + height - 23,
                }));
            }
            // Reward experience
            labelIDs.push((0, pixel_pigeon_1.createLabel)({
                color: retrommo_types_1.Color.White,
                coordinates: {
                    condition: () => exports.npcDialogueWorldMenu.state.values.questCompletion !== null &&
                        (0, isWorldCombatInProgress_1.isWorldCombatInProgress)() === false,
                    x: x + xOffset,
                    y: y + 33,
                },
                horizontalAlignment: "left",
                maxLines: 1,
                maxWidth: width - xOffset * 2,
                size: 1,
                text: () => {
                    if (exports.npcDialogueWorldMenu.state.values.questCompletion === null) {
                        throw new Error("No completed quest.");
                    }
                    const quest = (0, definables_1.getDefinable)(Quest_1.Quest, exports.npcDialogueWorldMenu.state.values.questCompletion.questID);
                    const pieces = [
                        `Experience gained: ${(0, getFormattedInteger_1.getFormattedInteger)(quest.experience)}`,
                    ];
                    if (exports.npcDialogueWorldMenu.state.values.questCompletion.didLevelUp) {
                        pieces.push(`(Leveled up to ${(0, getFormattedInteger_1.getFormattedInteger)(worldCharacter.player.character.level)}!)`);
                    }
                    return {
                        value: pieces.join(" "),
                    };
                },
            }));
            // Reward gold
            labelIDs.push((0, pixel_pigeon_1.createLabel)({
                color: retrommo_types_1.Color.White,
                coordinates: {
                    condition: () => exports.npcDialogueWorldMenu.state.values.questCompletion !== null &&
                        (0, isWorldCombatInProgress_1.isWorldCombatInProgress)() === false,
                    x: x + xOffset,
                    y: y + 44,
                },
                horizontalAlignment: "left",
                maxLines: 1,
                maxWidth: width - xOffset * 2,
                size: 1,
                text: () => {
                    if (exports.npcDialogueWorldMenu.state.values.questCompletion === null) {
                        throw new Error("No completed quest.");
                    }
                    const quest = (0, definables_1.getDefinable)(Quest_1.Quest, exports.npcDialogueWorldMenu.state.values.questCompletion.questID);
                    return {
                        value: `Gold earned: ${(0, getFormattedInteger_1.getFormattedInteger)(quest.gold)}`,
                    };
                },
            }));
        }
        return (0, pixel_pigeon_1.mergeHUDElementReferences)([
            {
                labelIDs,
            },
            ...hudElementReferences,
        ]);
    },
    initialStateValues: {
        questCompletion: null,
        selectedQuestIndex: null,
    },
    preventsWalking: true,
});
